// extracted by mini-css-extract-plugin
export default {"input_main":"ChangePassModal_input_main__4AaOG","main":"ChangePassModal_main__V4Lc0"};